export const accountAccessZhCN = {
  'acct.access.ui.keyword': '帐号ID / 登录邮箱 / 姓名',
  'acct.access.ui.detail': '帐号详情',
  'acct.access.ui.more': '更多',
  'acct.access.ui.moreLacks': '另缺 {count} 项',
  'acct.access.ui.undetermined': '暂不可判',
  'acct.access.ui.unmanagedHint': '未绑定帐号的属会',
  'acct.access.ui.allClubsManaged': '每一家属会都有帐号在管',
};
export const accountAccessZhHK = {
  'acct.access.ui.keyword': '帳號ID / 登入郵箱 / 姓名',
  'acct.access.ui.detail': '帳號詳情',
  'acct.access.ui.more': '更多',
  'acct.access.ui.moreLacks': '另缺 {count} 項',
  'acct.access.ui.undetermined': '暫不可判',
  'acct.access.ui.unmanagedHint': '未綁定帳號的屬會',
  'acct.access.ui.allClubsManaged': '每一家屬會都有帳號在管',
};
export const accountAccessEnUS = {
  'acct.access.ui.keyword': 'Account ID / sign-in email / name',
  'acct.access.ui.detail': 'Account details',
  'acct.access.ui.more': 'More',
  'acct.access.ui.moreLacks': '{count} more requirements',
  'acct.access.ui.undetermined': 'Undetermined',
  'acct.access.ui.unmanagedHint': 'Clubs without a linked account',
  'acct.access.ui.allClubsManaged': 'Every club has a managing account',
};
